import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  licenses: {
    update: {
      error: 'There is a problem updating the license',
      success: 'Tenant licenses updated successfully',
      unchanged: 'Licenses have not been changed',
    },
  },
  tenant: {
    list: {
      error: 'There is a problem retrieving the tenants',
    },
    create: {
      error: 'There is a problem creating the tenant',
      success: 'Tenant created successfully',
    },
    retrieve: {
      error: 'There is a problem retrieving the tenant details',
    },
    update: {
      error: 'There is a problem updating the tenant',
      success: 'Tenant updated successfully',
    },
    delete: {
      success: 'Tenant deleted successfully',
      error: 'There is a problem deleting the tenant',
    },
  },
  ratesheet: {
    update: {
      success: 'Ratesheet updated successfully',
      error: 'There is a problem updating the ratesheet',
      unchanged: 'Ratesheet have not been changed',
    },
  },
  user: {
    updated: 'User updated successfully',
    updateError: 'Error updating the user',
    enabled: 'User successfully enabled to the tenant',
    changedRole: 'Successfully changed role to the tenant',
    updateTenantError: 'Error updating the tenant to the user',
    deletedTenantAccess: 'Successfully removed the user access to the tenant',
    deletedTenantAccessError: 'Error removing the user access to the tenant',
  },
  isinRating: {
    success: 'ISIN Rating saved',
    error: 'Error saving ISIN rating',
  },
}
